import React, { Component, Fragment } from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import { Loader } from 'sa-ui';

import ProfilesCollapseCardContainer from './collapse-card/ProfilesCollapseCardContainer';
import ProfilesCollapseModal from './collapse-card/ProfilesCollapseModal';

import { getTeachers, changeTeacherEdit, removeTeacher } from './profilesActions';

import messages from './profilesMessages';

import './ProfilesContainer.scss';

class ProfilesContainer extends Component {
  state = {
    showModalProfileCreated: false,
    showModalRemoveCreated: false,
    teacherToRemove: '',
  };

  componentDidMount() {
    this.props.getTeachers();
  }

  handleChangeTeacherEdit = (params) => {
    this.props.changeTeacherEdit(params);
  };

  handleSelectTeacherToRemove = (teacherToRemove) => {
    this.setState({ teacherToRemove, showModalRemoveCreated: true }, () => console.log(this.state));
  };

  handleShowModalProfileCreated = (showModalProfileCreated) => {
    this.setState({ showModalProfileCreated });
  };

  handleShowModalRemoveCreated = (showModalRemoveCreated) => {
    this.setState({ showModalRemoveCreated });
  };

  handleRemoveTeacher = (idESUser) => {
    if (idESUser) {
      this.props.removeTeacher({ idESUser });
    } else {
      this.props.removeTeacher({ ...this.state.teacherToRemove });
    }
    this.setState({ teacherToRemove: '' }, () => {
      this.handleShowModalRemoveCreated(false);
      setTimeout(() => {
        this.props.getTeachers();
      }, 1000);
    });
  };

  render() {
    const { intl, teachers, history, isLoading, canEditSchool } = this.props;

    return (
      <Fragment>
        <Loader show={isLoading} />
        <div className="row">
          <div className="col-9">
            <div className="align-items-center margin-bottom">
              <h1 className="page-title">{intl.formatMessage(messages.title)}</h1>
              <h6 className="mt-2">{intl.formatMessage(messages.subtitle)}</h6>
            </div>
            {canEditSchool && (
              <a className="card add-new card-list" onClick={() => history.push('/profiles/add')}>
                <span>
                  <div className="container">
                    <div className="row align-items-center">
                      <div className="col-2">
                        <div className="add-icon my-0">
                          <i className="ti-plus" />
                        </div>
                      </div>
                      {/* <div className="col-8" onClick={() => this.handleShowModalProfileCreated(true)}> */}
                      <div className="col-8">{intl.formatMessage(messages.addProfile)}</div>
                    </div>
                  </div>
                </span>
              </a>
            )}

            <div className="accordion" id="accordionProfile">
              {teachers.map((teacher, i) => {
                let color = '#EFD581';
                if (i % 2 === 0) color = '#C5E2A9';
                if (i % 3 === 0) color = '#ABE0DE';
                if (i % 4 === 0) color = '#D4A1DD';

                return (
                  <ProfilesCollapseCardContainer
                    key={teacher.name}
                    messages={messages}
                    teacher={teacher}
                    color={color}
                    getTeachers={this.props.getTeachers}
                    changeTeacherEdit={this.handleChangeTeacherEdit}
                    selectTeacherToRemove={this.handleSelectTeacherToRemove}
                    removeTeacher={this.handleRemoveTeacher}
                  />
                );
              })}
            </div>
          </div>
        </div>
        <ProfilesCollapseModal
          type="profile-created"
          isOpen={this.state.showModalProfileCreated}
          messages={messages}
          onClose={() => this.handleShowModalProfileCreated(false)}
          onContinue={() => console.log('continue')}
          user={{ name: 'Bruce Wayne' }}
        />
        <ProfilesCollapseModal
          type="profile-remove"
          isOpen={this.state.showModalRemoveCreated}
          messages={messages}
          onClose={() => {
            this.setState({ teacherToRemove: '' }, () => this.handleShowModalRemoveCreated(false));
          }}
          onContinue={this.handleRemoveTeacher}
        />
      </Fragment>
    );
  }
}

function mapStateToProps({ app, profiles }) {
  return { user: app.user, canEditSchool: app.canEditSchool, ...profiles };
}

export default compose(
  injectIntl,
  connect(mapStateToProps, { getTeachers, changeTeacherEdit, removeTeacher }),
)(ProfilesContainer);
